import { useCallback, useEffect, useState } from "react";
import {
  fetchCompletionRate,
  fetchCsatScore,
  fetchDailyChats,
  fetchResolutionTimes,
} from "@/api/homeReportingApi";

async function loadAll(range, signal) {
  const [dailychats, completion, resolution, csat] = await Promise.all([
    fetchDailyChats(range, { signal }),
    fetchCompletionRate(range, { signal }),
    fetchResolutionTimes(range, { signal }),
    fetchCsatScore(range, { signal }),
  ]);
  return { dailychats, completion, resolution, csat };
}

export function useHomeMetrics({ startDate, endDate, enabled = true }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(/** @type {Error | null} */ (null));
  const [tick, setTick] = useState(0);

  const refresh = useCallback(() => {
    setTick((t) => t + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setError(null);
      setData(null);
      return undefined;
    }
    const ac = new AbortController();
    const range = { startDate, endDate };
    setLoading(true);
    setError(null);
    loadAll(range, ac.signal)
      .then((d) => {
        if (ac.signal.aborted) return;
        setData(d);
      })
      .catch((e) => {
        if (ac.signal.aborted) return;
        setError(e instanceof Error ? e : new Error(String(e)));
        setData(null);
      })
      .finally(() => {
        if (!ac.signal.aborted) setLoading(false);
      });
    return () => ac.abort();
  }, [startDate, endDate, tick, enabled]);

  return { data, loading, error, refresh };
}
